<script>
	import {mapGetters} from 'vuex'
	import uuid from 'uuid'
	import {db, loadSession} from '@/js/firebase'
	import dayjs from 'dayjs'
	export default {
		name: 'Session',
		data() {
			return {
				componentName: 'Session',
				code: '',
				secret: '',
				error: null,
				loading: false,
			}
		},
		components: {},
		props: [],
		computed: {
			...mapGetters(['session', 'account']),
		},
		watch: {
			$route: {
				handler(val) {
					if (
						val &&
						val.params.id &&
						val.params.id !== 'new' &&
						(!this.session || val.params.id !== this.session.id)
					) {
						console.log('LOAD SESSION')
						this.loadSession()
					}
				},
				immediate: true,
			},
		},
		methods: {
			loadSession() {
				loadSession(this.$route.params.id)
				// console.log('load sesson')
				// let id = this.$route.params.id
				// let code = this.code
				// let secret = this.secret
				// let query
				// console.log(id)
				// if (id) {
				// 	query = db.collection('session').where('id', '==', id)
				// } else if (code) {
				// 	query = db
				// 		.collection('session')
				// 		.where('code', '==', code)
				// 		.where('secret', '==', secret)
				// 		.where('userCount', '<=', 1)
				// } else {
				// 	return
				// }
				// query.onSnapshot(querySnapshot => {
				// 	querySnapshot.forEach(doc => {
				// 		console.log(doc.id, 'ON SNAP')
				// 		this.$store.dispatch('setSession', doc.data())
				// 	})
				// })
			},
			async createSession() {
				console.log('Create')
				let session = this.newSession()
				console.log(session)
				if (!session) {
					return (this.error = 'No secret provided')
				}
				this.loading = true
				console.log({session})
				let doc = db.collection('session').doc(session.id)
				await doc.set(session).catch(err => {
					console.log({err})
				})
				this.loading = false
				doc.onSnapshot(doc => {
					this.$store.dispatch('setSession', doc.data())
					this.$route.params.id = doc.id
					this.$route.params.invite = 'invite'
					this.$router.replace(this.$route)
				})
			},
			async renewCode() {
				if (!this.session || !this.session.id) {
					return
				}
				let code = Math.floor(Math.random() * (999999 - 100000) + 100000)
				this.code = code
				let codeExpires = dayjs()
					.add(1, 'day')
					.toDate()
				let doc = db.collection('session').doc(this.session.id)
				let newSession = await doc.update({code, codeExpires}).catch(err => {
					console.log({err})
				})
				console.log({newSession})
			},
			newSession() {
				let date = new Date()
				let id = uuid.v4()
				let code = Math.floor(Math.random() * (999999 - 100000) + 100000)
				let codeExpires = dayjs()
					.add(7, 'day')
					.toDate()
				if (!this.secret) {
					return
				}
				return {
					id,
					code,
					codeExpires,
					secret: this.secret,
					userCount: 1,
					created: date,
					updated: date,
					users: {
						[this.account.uid]: date,
					},
					mode: 'realtime',
					deleted: 0,
				}
			},
		},
		mounted() {
			// Called after the instance has just been mounted where el is replaced by the newly created vm.el. If the root instance is mounted to an in-document element, vm.el will also be in-document when mounted is called.
			this.$nextTick(() => {
				if (this.$route.params.invite) {
				}

				// console.log('<Session> is ready and attached to the dom', this)
			})
		},
	}
</script>
<!-- ******************************************************************* -->
<template>
	<div class="Session">
		{{ componentName }}
		New Session
		{{ session }}
		{{ account }}
		<v-btn @click="renewCode">
			Get a new code
		</v-btn>
		{{ code }}
		<v-text-field v-model="secret" label="Secret Word"></v-text-field>
		<v-btn @click="createSession">NEW</v-btn>
	</div>
</template>
<!-- ******************************************************************* -->
<style scoped>
	.Session {
	}
</style>
